export { default as VideoSingular } from './VideoSingular';